import moment from 'moment';
import { 
  BILLION_THRESHOLD, 
  DATE_DIMENSION, 
  MILLION_THRESHOLD, 
  MOMENT_DATE_ID, 
  THOUSAND_THRESHOLD,
} from '@/pages/dashboard/pages/overview/_config/constant';

// 判断是否超过一天, 一周或一个月
export const isGreater = (dateDimension: string, rangTime: string[] = [], interval = 1): boolean => {
  const startTime = moment(rangTime[0]);
  const endTime = moment(rangTime[1]);
  return endTime.diff(startTime, MOMENT_DATE_ID[dateDimension]) >= interval;
};

export const dateAdd = (dateDimension, time, addNum) => moment(time).add(addNum, MOMENT_DATE_ID[dateDimension]);

/**
 * 处理在 Day, Week , Month不同维度下, 显示的日期格式
 * @param dateDimension 日期维度
 * @param date 日期
 * @return 返回处理后符合产品要求的日期格式字符串
 */
export const getDateFormatString = (dateDimension, date: string) => {

  switch (dateDimension) {
    case DATE_DIMENSION.WEEK: {
      const weekOfDay = moment(date).format('E');
      return moment(date).subtract(Number(weekOfDay) - 1, 'days').format("YYYY-MM-DD");
    }
    case DATE_DIMENSION.MONTH: {
      return moment(date).format("YYYY-MM");
    }
    case DATE_DIMENSION.DAY:
    default:
      return moment(date).format("YYYY-MM-DD");

  }
};

export function hasOnly(range=['',''], type) {
  switch (type) {
    case 'Week':
      return moment(range[0]).subtract(moment(range[0]).format('E'), 'days').format('YYYY-MM-DD')
        === moment(range[1]).subtract(moment(range[1]).format('E'), 'days').format('YYYY-MM-DD');
    case 'Month':
      return moment(range[0]).format('YYYY-MM') === moment(range[1]).format('YYYY-MM');
    default:
      return range[0] === range[1];
  }
}

// 表示单位类型的枚举。Enum to represent unit types.
enum Unit {
  Thousand = 'K',
  Million = 'M',
  Billion = 'B',
}

/**
 * 将数值转换为具有适当单位的人类可读字符串。Converts a numeric value to a human-readable string with appropriate units.
 * @param {number} value - 要转换的数值。The numeric value to be converted.
 * @param {number} decimal - 小数位数（默认为 2）。The number of decimal places (default is 2).
 * @returns {string} - 具有适当单位的格式化字符串。The formatted string with appropriate units.
 */

interface FormatNumberParams {
  value: number;
  decimal?: number;
}

export const formatNumberWithUnits = ({ value, decimal = 2 }: FormatNumberParams): string => {
  if (value < THOUSAND_THRESHOLD) {
    return value.toFixed(decimal);
  } if (value < MILLION_THRESHOLD) {
    return (value / THOUSAND_THRESHOLD).toFixed(decimal) + Unit.Thousand;
  } if (value < BILLION_THRESHOLD) {
    return (value / MILLION_THRESHOLD).toFixed(decimal) + Unit.Million;
  } 
  return (value / BILLION_THRESHOLD).toFixed(decimal) + Unit.Billion;
  
};